// eslint-disable-next-line import/no-anonymous-default-export
export default (newAsset = [], action) => {
  switch (action.type) {
    case "GET_NEW_UNAPPROVED_ASSETS":
      return action.payload;
    case "CREATE_NEW_ASSET":
      return [...newAsset, action.payload];
    case "CREATE_NEW_BULK_ASSET":
      return [...newAsset, ...action.payload];

    case "APPROVE_NEW_ASSET":
      return newAsset.filter((lo) => lo._id !== action.payload);
    case "APPROVE_NEW_MANY_ASSET":
      return newAsset.filter((lo) => lo._id !== action.payload);

    case "UPDATE_NEW_ASSET": {
      const updated = action.payload?.data || action.payload;
      return newAsset.map((a) =>
        (a?._id || a?.id) === (updated?._id || updated?.id) ? updated : a,
      );
    }
    case "DELETE_NEW_ASSET":
      return newAsset.filter((lo) => lo._id !== action.payload);

    case "UPLOAD_EXCEL_ASSETS":
      return [...newAsset, ...action.payload];
    case "DELETE_NEW_BULK_ASSET":
      return newAsset.filter((lo) => lo._id !== action.payload);
    default:
      return newAsset;
  }
};
